/**
 * What the orphan chart says in words, which is the half a chart cannot.
 *
 * `NOT_SEARCHABLE` is most of these rows: a stop-transaction carries no
 * identifier at all, and every session on one lane sent a token class instead
 * of a card until the OCPP Server was repaired on 2026-09-08. A reader who does
 * not know that reads the chart as a service that looked and found nothing,
 * which cost three wrong explanations during the migration waves.
 *
 * So the count goes on the page as a sentence, not only as a line on a chart.
 * A line is read as a quantity; this needs to be read as a caveat.
 */

export function orphanReading(total: number, notSearchable: number): string {
  if (total === 0) {
    return 'No session event in this range arrived without a stamp.'
  }
  if (notSearchable === 0) {
    return `${total} session ${total === 1 ? 'event' : 'events'} arrived without a stamp, and every one of them carried something that can be looked up.`
  }
  if (notSearchable === total) {
    return `${total} session ${total === 1 ? 'event' : 'events'} arrived without a stamp, and not one of them carried anything that could be looked up. Nothing here says a decision was missing: it says we cannot ask.`
  }
  const share = Math.round((notSearchable / total) * 100)
  return `${total} session events arrived without a stamp. ${notSearchable} of them, ${share} per cent, carried nothing that could be looked up: a stop-transaction has no identifier, and one lane sent a token class rather than a card. For those the chart is not saying a decision was missing, it is saying we cannot ask.`
}
